
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Levallois-Perret dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Levallois-Perret certifiée Google Partner, aide les entreprises levalloisiennes à développer leur visibilité en ligne et accroître leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Levallois-Perret dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Levallois-Perret certifiée Google Partner, aide les entreprises levalloisiennes à développer leur visibilité en ligne et accroître leur clientèle.",
        },
      ],
    };
  },
};
